<template>
  <span
    v-if="status === PENDING"
    class="text-warning">
    {{ $t(`status.${docType}.pending`) }}
  </span>
  <span
    v-else-if="status === UNCOMPLETED"
    class="text-info">
    {{ $t(`status.${docType}.topay`) }}
  </span>
  <span
    v-else-if="status === COMPLETED"
    class="text-success">
    {{ $t(`status.${docType}.completed`) }}
  </span>
  <span
    v-else-if="status === REJECTED"
    class="text-danger">
    {{ $t(`status.${docType}.rejected`) }}
  </span>
</template>

<script>
import { DOCUMENT_RPOCESS_STATUS } from '@/helpers/enum'

export default {
  props: {
    docType: String,
    status: String,
  },

  data () {
    return {
      PENDING: DOCUMENT_RPOCESS_STATUS.PENDING,
      UNCOMPLETED: DOCUMENT_RPOCESS_STATUS.UNCOMPLETED,
      COMPLETED: DOCUMENT_RPOCESS_STATUS.COMPLETED,
      REJECTED: DOCUMENT_RPOCESS_STATUS.REJECTED,
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseDocumentProcessStatus.vue